/* ============================================================
   Routine Builder JS — Prescription Skincare
   Initialiseert elke section met [data-routine-builder].
   v4: multi-select op alle stappen (geen max), HTML download
       i.p.v. print, hover-fixes, Klaviyo integratie.
   ============================================================ */
(function () {
  'use strict';

  const STEPS = ['cleanse', 'peel', 'build', 'moisturize', 'protect'];
  const STEP_NUM = { cleanse: 1, peel: 2, build: 3, moisturize: 4, protect: 5 };
  // Basis-modus: alleen deze 3 stappen
  const REQUIRED_STEPS = ['cleanse', 'moisturize'];

  // i18n: lees vertaalde strings uit window.RB_TRANSLATIONS (gevuld door Liquid).
  // Fallback naar NL-defaults zodat de tool ook zonder bridge werkt.
  const T = (window.RB_TRANSLATIONS || {});
  const STEP_LABEL = (T.routine_label) || { cleanse: 'Reinigen', peel: 'Exfoliëren', build: 'Behandelen', moisturize: 'Hydrateren', protect: 'Beschermen' };

  // Helper: vervang placeholders {{ key }} in een vertaalde string.
  function tFmt(template, vars) {
    if (!template) return '';
    if (!vars) return template;
    return template.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) {
      return vars[k] !== undefined ? vars[k] : '';
    });
  }

  // Fallback conflict-paren op basis van product handles. Werkt zolang Maxime de
  // incompatible_with metafield nog niet heeft gevuld. Metafield-data heeft voorrang.
  const FALLBACK_CONFLICTS = [
    ['ascorbic-acid-20', 'niacinamide-7'],
    ['ascorbic-acid-20', 'retinol-palmitate-3-7'],
    ['retinol-palmitate-3-7', 'glycolic-acid-10'],
    ['retinol-palmitate-3-7', 'salicylic-acid-2-azelaic-acid-7'],
    ['retinol-palmitate-3-7', 'mandelic-acid-20'],
    ['glycolic-acid-10', 'salicylic-acid-2-azelaic-acid-7'],
    ['glycolic-acid-10', 'mandelic-acid-20'],
    ['salicylic-acid-2-azelaic-acid-7', 'mandelic-acid-20'],
  ];

  function formatMoney(cents) {
    const euros = (cents || 0) / 100;
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
    }).format(euros);
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function initRoutineBuilder(root) {
    if (root.dataset.rbInitialized) return;
    root.dataset.rbInitialized = '1';

    // Tier-systeem: kies hoogste van toepassing zijnde tier.
    const tiers = [
      {
        min: parseInt(root.dataset.tier1Min || '3', 10),
        percent: parseFloat(root.dataset.tier1Percent || '10'),
        code: root.dataset.tier1Code || ''
      },
      {
        min: parseInt(root.dataset.tier2Min || '4', 10),
        percent: parseFloat(root.dataset.tier2Percent || '15'),
        code: root.dataset.tier2Code || ''
      }
    ];
    const tiersDesc = tiers.slice().sort(function (a, b) { return b.min - a.min; });
    const tiersAsc = tiers.slice().sort(function (a, b) { return a.min - b.min; });
    const minProducts = tiersAsc[0].min; // laagste tier-drempel

    function activeTier(productCount) {
      for (var i = 0; i < tiersDesc.length; i++) {
        if (productCount >= tiersDesc[i].min) return tiersDesc[i];
      }
      return null;
    }
    function nextTier(productCount) {
      for (var i = 0; i < tiersAsc.length; i++) {
        if (productCount < tiersAsc[i].min) return tiersAsc[i];
      }
      return null;
    }
    const klaviyoCompanyId = root.dataset.klaviyoCompanyId || '';
    const klaviyoListId = root.dataset.klaviyoListId || '';
    const klaviyoEventName = root.dataset.klaviyoEventName || 'Routine Builder Completed';

    // v4: alle stappen zijn arrays (multi-select, geen limiet)
    const state = {
      routineType: 'volledig',
      concern: null,
      cleanse: [],
      peel: [],
      build: [],
      moisturize: [],
      protect: [],
      step: 0,
    };

    // Build product index + handle lookup
    const productIndex = {};
    const handleToId = {};
    root.querySelectorAll('[data-rb-product-card]').forEach((card) => {
      const id = card.dataset.productId;
      const handle = card.dataset.productHandle || '';
      const concerns = (card.dataset.concerns || '').split(',').map((c) => c.trim()).filter(Boolean);
      productIndex[id] = {
        id: id,
        handle: handle,
        step: card.dataset.step,
        variantId: card.dataset.variantId,
        name: card.dataset.productName,
        url: card.dataset.productUrl,
        position: card.dataset.productPosition || 'both',
        price: parseInt(card.dataset.productPrice || '0', 10),
        image: card.dataset.productImage || '',
        incompatible: (card.dataset.incompatibleWith || '').split(',').filter(Boolean),
        concerns: concerns,
        el: card,
      };
      if (handle) handleToId[handle] = id;
    });

    // Voeg fallback-conflicts toe aan productIndex op basis van handles
    FALLBACK_CONFLICTS.forEach((pair) => {
      const idA = handleToId[pair[0]];
      const idB = handleToId[pair[1]];
      if (!idA || !idB) return;
      const a = productIndex[idA];
      const b = productIndex[idB];
      if (a && a.incompatible.indexOf(idB) === -1) a.incompatible.push(idB);
      if (b && b.incompatible.indexOf(idA) === -1) b.incompatible.push(idA);
    });

    const $welcome = root.querySelector('[data-rb-welcome]');
    const $progress = root.querySelector('[data-rb-progress]');
    const $progressItems = root.querySelectorAll('[data-rb-progress] li');
    const $concern = root.querySelector('[data-rb-concern]');
    const $steps = root.querySelectorAll('.rb-step');

    /* ---------- Routine type toggle ---------- */
    root.querySelectorAll('[data-rb-type]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.routineType = btn.dataset.rbType;
        root.querySelectorAll('[data-rb-type]').forEach((b) => {
          b.classList.toggle('is-selected', b === btn);
        });
      });
    });

    /* ---------- Concern chips ---------- */
    root.querySelectorAll('[data-rb-chip]').forEach((chip) => {
      chip.addEventListener('click', () => {
        const value = chip.dataset.rbChip;
        state.concern = state.concern === value ? null : value;
        root.querySelectorAll('[data-rb-chip]').forEach((c) => {
          c.classList.toggle('is-selected', c.dataset.rbChip === state.concern);
        });
        const nextBtn = root.querySelector('[data-rb-concern-next]');
        if (nextBtn) nextBtn.disabled = !state.concern;
      });
    });

    const concernNext = root.querySelector('[data-rb-concern-next]');
    if (concernNext) {
      concernNext.addEventListener('click', () => {
        applyRecommendations();
        showStepsView();
        goToStep(1);
      });
    }
    const concernSkip = root.querySelector('[data-rb-concern-skip]');
    if (concernSkip) {
      concernSkip.addEventListener('click', () => {
        state.concern = null;
        applyRecommendations();
        showStepsView();
        goToStep(1);
      });
    }
    const concernBack = root.querySelector('[data-rb-concern-back]');
    if (concernBack) concernBack.addEventListener('click', showWelcomeView);

    /* ---------- Card selection (multi-select) ---------- */
    root.querySelectorAll('[data-rb-product-card]').forEach((card) => {
      card.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const stepKey = card.dataset.step;
        const productId = card.dataset.productId;
        selectProduct(stepKey, productId);
        if (document.activeElement && typeof document.activeElement.blur === 'function') {
          document.activeElement.blur();
        }
      });
    });

    function selectProduct(stepKey, id) {
      let arr = state[stepKey];
      if (arr.indexOf(id) !== -1) {
        state[stepKey] = arr.filter((x) => x !== id);
      } else {
        state[stepKey] = arr.concat([id]);
      }
      refreshStepUI(stepKey);
    }

    function refreshStepUI(stepKey) {
      const cards = root.querySelectorAll('[data-rb-product-card][data-step="' + stepKey + '"]');
      const sel = state[stepKey];
      cards.forEach((card) => {
        const id = card.dataset.productId;
        card.classList.toggle('is-selected', sel.indexOf(id) !== -1);
      });
      const stepNum = STEP_NUM[stepKey];
      const nextBtn = root.querySelector('[data-rb-next="' + stepNum + '"]');
      if (nextBtn) {
        const isOptional = REQUIRED_STEPS.indexOf(stepKey) === -1;
        nextBtn.disabled = !isOptional && !hasSelection(stepKey);
      }
      // Conflicts kunnen cross-step zijn (bijv. Retinol uit Build + Glycolic uit Peel).
      // Tip update na elke selectie zodat 'm klopt zodra de gebruiker bij Build komt.
      updateConflictTip();
    }

    function hasSelection(stepKey) {
      return state[stepKey].length > 0;
    }

    // Vindt het eerste conflicterende paar over alle gekozen producten (cross-step).
    function findConflictPair() {
      const ids = [];
      ['cleanse', 'peel', 'build', 'moisturize', 'protect'].forEach((k) => {
        if (state.routineType === 'basis' && (k === 'peel' || k === 'build')) return;
        ids.push.apply(ids, state[k]);
      });
      for (let i = 0; i < ids.length; i++) {
        for (let j = i + 1; j < ids.length; j++) {
          const a = productIndex[ids[i]];
          const b = productIndex[ids[j]];
          if (!a || !b) continue;
          if (a.incompatible.indexOf(b.id) !== -1 || b.incompatible.indexOf(a.id) !== -1) {
            return [a, b];
          }
        }
      }
      return null;
    }

    function updateConflictTip() {
      const buildBanner = root.querySelector('[data-rb-tip-build]');
      const buildText = root.querySelector('[data-rb-tip-text]');
      const summaryBanner = root.querySelector('[data-rb-tip-summary]');
      const summaryText = root.querySelector('[data-rb-tip-summary-text]');
      const pair = findConflictPair();
      if (pair) {
        const a = pair[0], b = pair[1];
        let msg;
        const hasAm = a.position === 'am' || b.position === 'am';
        const hasPm = a.position === 'pm' || b.position === 'pm';
        const conflictTpl = (T.conflict) || {
          split_am_pm: '{{ name_a }} en {{ name_b }} werken niet ideaal samen in één moment. Gebruik {{ am_name }} \'s ochtends en {{ pm_name }} \'s avonds.',
          same_time: '{{ name_a }} en {{ name_b }} werken niet ideaal samen op dezelfde dag. Wissel ze af op verschillende dagen of momenten.'
        };
        if (hasAm && hasPm) {
          const amProd = a.position === 'am' ? a : b;
          const pmProd = amProd === a ? b : a;
          msg = tFmt(conflictTpl.split_am_pm, { name_a: a.name, name_b: b.name, am_name: amProd.name, pm_name: pmProd.name });
        } else {
          msg = tFmt(conflictTpl.same_time, { name_a: a.name, name_b: b.name });
        }
        if (buildText) buildText.textContent = msg;
        if (buildBanner) buildBanner.classList.add('is-active');
        if (summaryText) summaryText.textContent = msg;
        if (summaryBanner) summaryBanner.classList.add('is-active');
      } else {
        if (buildBanner) buildBanner.classList.remove('is-active');
        if (summaryBanner) summaryBanner.classList.remove('is-active');
      }
    }

    /* ---------- Recommendation badges ---------- */
    function applyRecommendations() {
      const concern = state.concern;
      root.querySelectorAll('[data-rb-product-card]').forEach((card) => {
        if (!concern) { card.classList.remove('is-recommended'); return; }
        const cardConcerns = (card.dataset.concerns || '').split(',').map((c) => c.trim());
        card.classList.toggle('is-recommended', cardConcerns.indexOf(concern) !== -1);
      });
    }

    /* ---------- Step skip-logic voor basis-modus ---------- */
    function isStepActiveInMode(stepNum) {
      if (state.routineType === 'volledig') return true;
      return [1, 4, 5].indexOf(stepNum) !== -1;
    }
    function nextRelevantStep(from) {
      let n = from + 1;
      while (n <= 5 && !isStepActiveInMode(n)) n++;
      return n;
    }
    function prevRelevantStep(from) {
      let n = from - 1;
      while (n >= 1 && !isStepActiveInMode(n)) n--;
      return n;
    }
    function updateProgressBar() {
      $progressItems.forEach((li) => {
        const s = parseInt(li.dataset.step, 10);
        if (s === 6) return;
        li.style.display = isStepActiveInMode(s) ? '' : 'none';
      });
    }

    /* ---------- Navigation ---------- */
    root.querySelectorAll('[data-rb-start]').forEach((b) => b.addEventListener('click', showConcernView));
    root.querySelectorAll('[data-rb-next]').forEach((b) => b.addEventListener('click', () => {
      goToStep(nextRelevantStep(parseInt(b.dataset.rbNext, 10)));
    }));
    root.querySelectorAll('[data-rb-goto]').forEach((b) => b.addEventListener('click', () => {
      const to = parseInt(b.dataset.rbGoto, 10);
      if (to === 0) { showConcernView(); return; }
      goToStep(prevRelevantStep(to + 1));
    }));
    root.querySelectorAll('[data-rb-skip]').forEach((b) => b.addEventListener('click', () => {
      const stepNum = parseInt(b.dataset.rbSkip, 10);
      const key = STEPS[stepNum - 1];
      state[key] = [];
      refreshStepUI(key);
      goToStep(nextRelevantStep(stepNum));
    }));
    root.querySelectorAll('[data-rb-restart]').forEach((b) => b.addEventListener('click', restart));

    function showWelcomeView() {
      state.step = 0;
      $welcome.hidden = false;
      $progress.hidden = true;
      if ($concern) $concern.hidden = true;
      $steps.forEach((s) => s.classList.remove('is-active'));
      maybeScroll();
    }
    function showConcernView() {
      state.step = 0.5;
      $welcome.hidden = true;
      if ($concern) $concern.hidden = false;
      $progress.hidden = true;
      $steps.forEach((s) => s.classList.remove('is-active'));
      maybeScroll();
    }
    function showStepsView() {
      $welcome.hidden = true;
      if ($concern) $concern.hidden = true;
      $progress.hidden = false;
      updateProgressBar();
    }
    function goToStep(n) {
      state.step = n;
      $welcome.hidden = true;
      if ($concern) $concern.hidden = true;
      $progress.hidden = false;
      $steps.forEach((s) => {
        s.classList.toggle('is-active', parseInt(s.dataset.step, 10) === n);
      });
      $progressItems.forEach((li) => {
        const s = parseInt(li.dataset.step, 10);
        li.classList.toggle('is-active', s === n);
        li.classList.toggle('is-done', s < n && isStepActiveInMode(s));
      });
      if (n === 6) {
        renderSummary();
        updateConflictTip();
      }
      maybeScroll();
    }
    function maybeScroll() {
      const rect = root.getBoundingClientRect();
      if (rect.top < 0) {
        window.scrollTo({ top: window.pageYOffset + rect.top - 80, behavior: 'smooth' });
      }
    }

    function restart() {
      state.routineType = 'volledig';
      state.concern = null;
      STEPS.forEach((k) => { state[k] = []; });
      STEPS.forEach((k) => refreshStepUI(k));
      root.querySelectorAll('[data-rb-type]').forEach((b) => {
        b.classList.toggle('is-selected', b.dataset.rbType === 'volledig');
      });
      root.querySelectorAll('[data-rb-chip]').forEach((c) => c.classList.remove('is-selected'));
      const cNext = root.querySelector('[data-rb-concern-next]');
      if (cNext) cNext.disabled = true;
      applyRecommendations();
      const emailInput = root.querySelector('[data-rb-email]');
      const emailStatus = root.querySelector('[data-rb-email-status]');
      if (emailInput) emailInput.value = '';
      if (emailStatus) { emailStatus.textContent = ''; emailStatus.classList.remove('is-active', 'is-error'); }
      const err = root.querySelector('[data-rb-error]');
      if (err) err.classList.remove('is-active');
      showWelcomeView();
    }

    /* ---------- Summary ---------- */
    function getSelectedProducts() {
      const ids = [];
      STEPS.forEach((k) => {
        if (state.routineType === 'basis' && (k === 'peel' || k === 'build')) return;
        ids.push.apply(ids, state[k]);
      });
      return ids.map((id) => productIndex[id]).filter(Boolean);
    }

    function renderSummary() {
      const selected = getSelectedProducts();
      const am = [];
      const pm = [];
      selected.forEach((p) => {
        if (p.position === 'am' || p.position === 'both') am.push(p);
        if (p.position === 'pm' || p.position === 'both') pm.push(p);
      });
      am.sort((a, b) => STEP_NUM[a.step] - STEP_NUM[b.step]);
      pm.sort((a, b) => STEP_NUM[a.step] - STEP_NUM[b.step]);

      root.querySelector('[data-rb-am]').innerHTML = renderRoutineList(am);
      root.querySelector('[data-rb-pm]').innerHTML = renderRoutineList(pm);

      const subtotal = selected.reduce((s, p) => s + p.price, 0);
      const n = selected.length;
      const tier = activeTier(n);
      const pct = tier ? tier.percent : 0;
      const discountAmount = Math.round(subtotal * pct / 100);
      const total = subtotal - discountAmount;

      root.querySelector('[data-rb-subtotal]').textContent = formatMoney(subtotal);
      const discLine = root.querySelector('[data-rb-discount-line]');
      const discLabel = root.querySelector('[data-rb-discount-label]');
      if (pct > 0) {
        discLine.style.display = 'flex';
        root.querySelector('[data-rb-discount-amount]').textContent = '-' + formatMoney(discountAmount);
        // Update label-tekst voor de juiste tier
        if (discLabel && T.summary) {
          const labelKey = tier === tiersDesc[0] ? 'discount_line_tier2' : 'discount_line_tier1';
          if (T.summary[labelKey]) discLabel.textContent = T.summary[labelKey];
        }
      } else {
        discLine.style.display = 'none';
      }
      root.querySelector('[data-rb-total]').textContent = formatMoney(total);

      const text = root.querySelector('[data-rb-bundle-text]');
      const bar = root.querySelector('[data-rb-bundle-bar]');
      const bundleT = (T.bundle) || {};
      const top = tiersDesc[0];

      // Helper: bouw "**label** detail" met echte DOM-elementen
      function renderActive(detailText) {
        text.textContent = '';
        const strong = document.createElement('strong');
        strong.textContent = bundleT.tier_active_label || 'Bundle discount active.';
        text.appendChild(strong);
        text.appendChild(document.createTextNode(' ' + detailText));
      }

      if (n >= top.min) {
        // Hoogste tier actief
        const detail = tFmt(bundleT.tier2_active_detail || 'You get {{ percent }}% off.', { percent: top.percent });
        renderActive(detail);
        bar.style.width = '100%';
      } else if (tier) {
        // Tier 1 actief, tier 2 nog te bereiken
        const detail = tFmt(bundleT.tier1_active_detail || 'You get {{ percent }}% off.', { percent: tier.percent });
        const next = nextTier(n);
        if (next) {
          const remaining = next.min - n;
          const tplKey = remaining === 1
            ? (next === tiersDesc[0] ? 'next_tier2_one' : 'next_tier1_one')
            : (next === tiersDesc[0] ? 'next_tier2_other' : 'next_tier1_other');
          const tpl = bundleT[tplKey] || 'Add {{ remaining }} more for {{ percent }}% off.';
          renderActive(detail + ' ' + tFmt(tpl, { remaining: remaining, percent: next.percent }));
        } else {
          renderActive(detail);
        }
        bar.style.width = Math.round((n / top.min) * 100) + '%';
      } else {
        // Geen tier actief — toon alleen "Nog X voor Y%"
        const next = nextTier(n) || tiersAsc[0];
        const remaining = next.min - n;
        const tplKey = remaining === 1 ? 'next_tier1_one' : 'next_tier1_other';
        const tpl = bundleT[tplKey] || 'Add {{ remaining }} more for {{ percent }}% off.';
        text.textContent = tFmt(tpl, { remaining: remaining, percent: next.percent });
        bar.style.width = Math.round((n / top.min) * 100) + '%';
      }
      const addBtn = root.querySelector('[data-rb-add-to-cart]');
      if (addBtn) addBtn.disabled = n === 0;
    }

    function renderRoutineList(items) {
      if (items.length === 0) {
        const empty = (T.summary && T.summary.empty_routine) || 'Geen producten in dit moment.';
        return '<div style="color:var(--p-skin-5);font-size:13px;font-style:italic;padding:8px 0;">' + escapeHtml(empty) + '</div>';
      }
      return items.map((p) => (
        '<div class="rb-routine-item">' +
          '<div class="rb-step-num">' + STEP_NUM[p.step] + '</div>' +
          '<div class="rb-step-info">' +
            '<div class="label">' + STEP_LABEL[p.step] + '</div>' +
            '<div class="name">' + escapeHtml(p.name) + '</div>' +
          '</div>' +
          '<div class="rb-step-price">' + formatMoney(p.price) + '</div>' +
        '</div>'
      )).join('');
    }

    /* ---------- Cart toevoegen ---------- */
    const addBtn = root.querySelector('[data-rb-add-to-cart]');
    if (addBtn) addBtn.addEventListener('click', addAllToCart);

    function addAllToCart() {
      const selected = getSelectedProducts();
      if (selected.length === 0) return;
      const loader = root.querySelector('[data-rb-loader]');
      const errorEl = root.querySelector('[data-rb-error]');
      if (loader) {
        loader.classList.add('is-active');
        const summaryT = (T.summary) || {};
        loader.textContent = summaryT.loader_default || 'Bezig met toevoegen aan mandje…';
      }
      if (errorEl) errorEl.classList.remove('is-active');
      addBtn.disabled = true;

      const items = selected.map(function (p) {
        return {
          id: parseInt(p.variantId, 10),
          quantity: 1,
          properties: { '_routine_builder': 'true', '_routine_step': p.step }
        };
      });

      // Tier bepalen vóór de fetch (in scope voor de .then-callbacks)
      const tier = activeTier(selected.length);
      console.log('[RoutineBuilder] cart-add starting. Tier:', tier);

      // Helper: open de Wonder cart-drawer (probeer meerdere patronen).
      function openCartDrawer() {
        // Trigger via cart-icoon met echte MouseEvent (Wonder refresht zelf bij open).
        const cartIcon = document.querySelector('.wt-cart__trigger, #cart-icon-bubble, [data-cart-drawer-trigger]');
        if (cartIcon) {
          cartIcon.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          return true;
        }
        return false;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          console.log('[RoutineBuilder] cart-add response:', res.status);
          if (!res.ok) {
            return res.text().then(function (txt) {
              throw new Error('Cart add mislukt (' + res.status + '): ' + txt.slice(0, 200));
            });
          }
          return res.json();
        })
        .then(function () {
          // Apply discount-code in de cart-cookie zonder page-navigatie.
          if (tier && tier.code) {
            return fetch('/discount/' + encodeURIComponent(tier.code), { credentials: 'same-origin' })
              .then(function () { console.log('[RoutineBuilder] discount applied:', tier.code); })
              .catch(function () { /* discount apply faalt zelden, negeren */ });
          }
        })
        .then(function () {
          if (loader) loader.classList.remove('is-active');
          addBtn.disabled = false;
          // Trigger cart-drawer. Lukt dat niet, fallback naar /cart.
          const opened = openCartDrawer();
          console.log('[RoutineBuilder] cart-drawer opened:', opened);
          if (!opened) {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          console.error('[RoutineBuilder] cart-add error:', err);
          if (loader) loader.classList.remove('is-active');
          addBtn.disabled = false;
          if (errorEl) {
            const tpl = (T.summary && T.summary.cart_error) || 'Er ging iets mis: {{ error }}. Probeer het opnieuw.';
            errorEl.textContent = tFmt(tpl, { error: err.message });
            errorEl.classList.add('is-active');
          }
        });
    }

    /* ---------- Klaviyo ---------- */
    const sendBtn = root.querySelector('[data-rb-send-email]');
    if (sendBtn) sendBtn.addEventListener('click', sendRoutineByEmail);

    function setEmailStatus(text, isError) {
      const el = root.querySelector('[data-rb-email-status]');
      if (!el) return;
      el.textContent = text;
      el.classList.add('is-active');
      el.classList.toggle('is-error', !!isError);
    }

    function sendRoutineByEmail() {
      const emailT = (T.email) || {};
      const input = root.querySelector('[data-rb-email]');
      const email = input && input.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setEmailStatus(emailT.invalid || 'Vul een geldig e-mailadres in.', true);
        return;
      }
      if (!klaviyoCompanyId) {
        setEmailStatus(emailT.not_configured || 'E-mail versturen is nog niet geconfigureerd. Gebruik download als alternatief.', true);
        return;
      }

      const selected = getSelectedProducts();
      const subtotal = selected.reduce(function (s, p) { return s + p.price; }, 0);
      const n = selected.length;
      const tier = activeTier(n);
      const pct = tier ? tier.percent : 0;
      const discountAmount = Math.round(subtotal * pct / 100);
      const total = subtotal - discountAmount;

      // Maak URLs absoluut. In e-mail is er geen base-URL, dus relatieve paden
      // (/products/...) en protocol-relatieve paden (//cdn...) breken.
      const origin = window.location.origin;
      function absUrl(u) {
        if (!u) return '';
        if (u.indexOf('//') === 0) return 'https:' + u;  // //cdn.shopify.com/...
        if (u.indexOf('http') === 0) return u;           // al absoluut
        return origin + u;                               // /products/...
      }

      // Cart-permalink: alle varianten in één klik, korting meteen toegepast.
      const cartUrl = origin + '/cart/' +
        selected.map(function (p) { return p.variantId + ':1'; }).join(',') +
        (tier && tier.code ? '?discount=' + encodeURIComponent(tier.code) : '');

      const properties = {
        Concern: state.concern || (T.concern_no_preference || 'geen voorkeur'),
        RoutineType: state.routineType,
        ProductCount: n,
        Subtotal: subtotal / 100,
        DiscountPercent: pct,
        Total: total / 100,
        DiscountCode: tier ? tier.code : '',
        CartUrl: cartUrl,
        AM_Products: selected.filter(function (p) { return p.position === 'am' || p.position === 'both'; })
          .sort(function (a, b) { return STEP_NUM[a.step] - STEP_NUM[b.step]; })
          .map(function (p) { return { name: p.name, step: STEP_LABEL[p.step], url: absUrl(p.url), price: p.price / 100, image: absUrl(p.image) }; }),
        PM_Products: selected.filter(function (p) { return p.position === 'pm' || p.position === 'both'; })
          .sort(function (a, b) { return STEP_NUM[a.step] - STEP_NUM[b.step]; })
          .map(function (p) { return { name: p.name, step: STEP_LABEL[p.step], url: absUrl(p.url), price: p.price / 100, image: absUrl(p.image) }; }),
      };

      sendBtn.disabled = true;
      setEmailStatus(emailT.sending || 'Bezig met versturen…', false);

      const eventBody = {
        data: {
          type: 'event',
          attributes: {
            properties: properties,
            metric: { data: { type: 'metric', attributes: { name: klaviyoEventName } } },
            profile: { data: { type: 'profile', attributes: { email: email } } },
            time: new Date().toISOString(),
          },
        },
      };

      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(klaviyoCompanyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(eventBody),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Klaviyo gaf status ' + res.status);
          if (klaviyoListId) {
            return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klaviyoCompanyId), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    custom_source: 'Routine Builder',
                    profile: { data: { type: 'profile', attributes: { email: email } } },
                  },
                  relationships: { list: { data: { type: 'list', id: klaviyoListId } } },
                },
              }),
            }).catch(function () { return null; });
          }
        })
        .then(function () {
          setEmailStatus(tFmt(emailT.success || 'Verzonden naar {{ email }}. Check je inbox.', { email: email }), false);
        })
        .catch(function (err) {
          setEmailStatus(tFmt(emailT.error || 'Versturen lukte niet: {{ error }}. Probeer download als alternatief.', { error: err.message }), true);
          sendBtn.disabled = false;
        });
    }

    /* ---------- PDF download via html2pdf ---------- */
    /* ---------- PDF download via jsPDF (text-mode) ---------- */
    const downloadBtn = root.querySelector('[data-rb-download]');
    if (downloadBtn) downloadBtn.addEventListener('click', downloadRoutinePdf);

    function downloadRoutinePdf() {
      const selected = getSelectedProducts();

      // Maak URLs absoluut. In e-mail is er geen base-URL, dus relatieve paden
      // (/products/...) en protocol-relatieve paden (//cdn...) breken.
      const origin = window.location.origin;
      function absUrl(u) {
        if (!u) return '';
        if (u.indexOf('//') === 0) return 'https:' + u;  // //cdn.shopify.com/...
        if (u.indexOf('http') === 0) return u;           // al absoluut
        return origin + u;                               // /products/...
      }

      if (selected.length === 0) return;

      if (!window.jspdf || !window.jspdf.jsPDF) {
        alert((T.download && T.download.failed) || 'PDF-library is niet geladen. Vernieuw de pagina en probeer opnieuw.');
        return;
      }

      const am = [], pm = [];
      selected.forEach(function (p) {
        if (p.position === 'am' || p.position === 'both') am.push(p);
        if (p.position === 'pm' || p.position === 'both') pm.push(p);
      });
      am.sort(function (a, b) { return STEP_NUM[a.step] - STEP_NUM[b.step]; });
      pm.sort(function (a, b) { return STEP_NUM[a.step] - STEP_NUM[b.step]; });

      const subtotal = selected.reduce(function (s, p) { return s + p.price; }, 0);
      const n = selected.length;
      const tier = activeTier(n);
      const pct = tier ? tier.percent : 0;
      const discountCode = tier ? tier.code : '';
      const discountPct = pct;
      const discountAmount = Math.round(subtotal * pct / 100);
      const total = subtotal - discountAmount;

      // Cart-permalink: voegt alle varianten in één klik toe én zet de korting.
      const cartUrl = origin + '/cart/' +
        selected.map(function (p) { return p.variantId + ':1'; }).join(',') +
        (tier && tier.code ? '?discount=' + encodeURIComponent(tier.code) : '');

      const today = new Date();
      const docLang = document.documentElement.lang || 'nl';
      const dateStr = today.toLocaleDateString(docLang, { day: 'numeric', month: 'long', year: 'numeric' });
      const dl = (T.download) || {};
      const concernLabel = state.concern
        ? state.concern.charAt(0).toUpperCase() + state.concern.slice(1)
        : (T.concern_no_preference || 'Geen voorkeur');

      const PDFLib = window.jspdf.jsPDF;
      const pdf = new PDFLib({ unit: 'mm', format: 'a4', orientation: 'portrait' });

      // Kleuren (RGB)
      const AUBERGINE = [83, 48, 66];
      const SKIN5     = [172, 144, 130];
      const PEACH     = [208, 157, 138];
      const TEXT_SOFT = [125, 102, 120];
      const SKIN3_BG  = [231, 223, 212];

      const W = 210, M = 18; // A4 breedte + margin

      // --- Header ---
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8);
      pdf.setTextColor.apply(pdf, SKIN5);
      pdf.text('BUILD YOUR PRESCRIPTION', W / 2, 20, { align: 'center' });

      pdf.setFont('times', 'normal');
      pdf.setFontSize(24);
      pdf.setTextColor.apply(pdf, AUBERGINE);
      pdf.text(dl.word_title || 'Mijn skincare routine', W / 2, 32, { align: 'center' });

      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(9);
      pdf.setTextColor.apply(pdf, TEXT_SOFT);
      const subtitle = tFmt(dl.word_subtitle || 'Opgesteld op {{ date }} · Huidwens: {{ concern }}', { date: dateStr, concern: concernLabel });
      pdf.text(subtitle, W / 2, 39, { align: 'center' });

      // --- Helper: render een routine-tabel ---
      function drawTable(title, items, startY) {
        pdf.setFont('times', 'normal');
        pdf.setFontSize(14);
        pdf.setTextColor.apply(pdf, AUBERGINE);
        pdf.text(title, M, startY);

        if (!items.length) {
          pdf.setFont('helvetica', 'italic');
          pdf.setFontSize(10);
          pdf.setTextColor.apply(pdf, TEXT_SOFT);
          pdf.text(dl.word_empty || 'Geen producten in dit moment.', M, startY + 7);
          return startY + 14;
        }

        const rows = items.map(function (p) {
          return [
            String(STEP_NUM[p.step]),
            STEP_LABEL[p.step],
            p.name,
            formatMoney(p.price)
          ];
        });

        pdf.autoTable({
          startY: startY + 4,
          head: [['#', 'STAP', 'PRODUCT', 'PRIJS']],
          body: rows,
          theme: 'plain',
          styles: { font: 'helvetica', fontSize: 10, textColor: AUBERGINE, cellPadding: 3 },
          headStyles: { fontSize: 8, textColor: SKIN5, fontStyle: 'bold' },
          columnStyles: {
            0: { cellWidth: 10, halign: 'center' },
            1: { cellWidth: 28, fontStyle: 'normal' },
            2: { cellWidth: 'auto' },
            3: { cellWidth: 22, halign: 'right' }
          },
          didDrawCell: function (data) {
            if (data.section === 'body' && data.column.index === 0) {
              // Optioneel: lijn onder elke rij
            }
          }
        });
        return pdf.lastAutoTable.finalY;
      }

      let y = 52;
      y = drawTable(dl.word_morning || '☀ Ochtend', am, y);
      y = drawTable(dl.word_evening || '☾ Avond', pm, y + 6);

      // --- Totalen blok ---
      y += 10;
      pdf.setFillColor.apply(pdf, SKIN3_BG);
      pdf.roundedRect(M, y, W - 2 * M, pct > 0 ? 32 : 24, 2, 2, 'F');

      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(10);
      pdf.setTextColor.apply(pdf, AUBERGINE);
      pdf.text(tFmt(dl.word_subtotal_label || 'Subtotaal ({{ count }} producten)', { count: n }), M + 4, y + 7);
      pdf.text(formatMoney(subtotal), W - M - 4, y + 7, { align: 'right' });

      let lineY = y + 13;
      if (pct > 0) {
        pdf.setTextColor.apply(pdf, PEACH);
        pdf.setFont('helvetica', 'bold');
        pdf.text(tFmt(dl.word_discount_label || 'Bundelkorting ({{ percent }}%)', { percent: discountPct }), M + 4, lineY);
        pdf.text('-' + formatMoney(discountAmount), W - M - 4, lineY, { align: 'right' });
        lineY += 6;
      }

      pdf.setDrawColor.apply(pdf, [216, 197, 186]);
      pdf.line(M + 4, lineY, W - M - 4, lineY);
      lineY += 6;

      pdf.setFont('times', 'normal');
      pdf.setFontSize(14);
      pdf.setTextColor.apply(pdf, AUBERGINE);
      pdf.text(dl.word_total || 'Totaal', M + 4, lineY);
      pdf.text(formatMoney(total), W - M - 4, lineY, { align: 'right' });

      // --- Discount code ---
      if (pct > 0) {
        y = lineY + 14;
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(10);
        pdf.setTextColor.apply(pdf, AUBERGINE);
        const codeText = tFmt(dl.word_code_text || 'Gebruik kortingscode {{ code }} aan de checkout voor {{ percent }}% korting.', { code: discountCode, percent: discountPct });
        pdf.text(codeText, W / 2, y, { align: 'center' });
      }

      // --- Footer ---
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8);
      pdf.setTextColor.apply(pdf, TEXT_SOFT);
      pdf.text(dl.word_footer_tagline || 'Prescription Skincare — Clinical. Clean. Conscious.', W / 2, 280, { align: 'center' });
      pdf.setTextColor.apply(pdf, SKIN5);
      pdf.text(dl.word_footer_order || 'Bestel je routine op prescription-beauty.nl', W / 2, 285, { align: 'center' });

      pdf.save('Prescription-routine-' + today.toISOString().slice(0, 10) + '.pdf');
    }

    /* ---------- Init ---------- */
    STEPS.forEach((k) => refreshStepUI(k));
    showWelcomeView();
  }

  function init() {
    document.querySelectorAll('[data-routine-builder]').forEach(initRoutineBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const root = e.target.querySelector('[data-routine-builder]');
    if (root) initRoutineBuilder(root);
  });
})();